import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Button, Hint } from '@src/components';
import { ReminderComposerFields, type ReminderRecipient } from '../BoxPage/BulkReminder';
import { usePremiumPageCopy } from './copy';

/** A local-only preview of the actual reminder composer; nothing is delivered. */
export function BulkMessagingExample() {
  const copy = usePremiumPageCopy();
  const { t } = useTranslation();
  const recipients: ReminderRecipient[] = [
    { id: 1, username: copy.olivia, picture: 'rabbit', avatar: '', frameName: undefined },
    { id: 2, username: copy.michael, picture: 'bear', avatar: '', frameName: undefined },
  ];
  const [message, setMessage] = useState(() => copy.bulkMessaging.message);
  const [previewed, setPreviewed] = useState(false);
  return <div className="premium-bulk-example" data-testid="premium-bulk-example">
    <div className="bulk-reminder">
      <ReminderComposerFields recipients={recipients} channels={[
        { id: 1, hasEmail: true, email: true, telegram: false, vk: false },
        { id: 2, hasEmail: true, email: true, telegram: false, vk: false },
      ]} scrollRecipients={false} showHints={false} rows={3} message={message} onMessageChange={value => { setMessage(value); setPreviewed(false); }} />
    </div>
    <Button fullWidth variant="secondary" disabled={!message.trim()} onClick={() => setPreviewed(true)} testId="premium-bulk-example-send">{t('bulkReminder.send', { count: recipients.length })}</Button>
    {previewed ? <Hint tone="success" testId="premium-bulk-example-result">{copy.bulkMessaging.previewResult}</Hint> : <Typography as="p" role="meta/helper">{copy.bulkMessaging.demoHint}</Typography>}
  </div>;
}
